import Button from '@blaze-react/button';
import Input from '@blaze-react/input';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ModalInText from './ModalInText';
import { checkValidEmail } from '../../utils';

const FormInText = ({ product, subtitle, title }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [values, setValues] = useState({ email: '' });

  const { email } = values;

  const isEmailSet = !!checkValidEmail(email);

  const buttonClass = classnames('newsletter-signup__submit', {
    'newsletter-signup__submit--disabled': !isEmailSet
  });

  const handleChange = ({ target: { name: targetName } }, value) => {
    setValues({
      email,
      [targetName]: value
    });
  };

  return (
    <div className="newsletter-signup__form newsletter-signup__form--embedded newsletter-signup__form--repeated">
      <div className="newsletter-signup__header">
        <div className="newsletter-signup__title-wrapper">
          <h2 className="newsletter-signup__title">{title}</h2>

          <p className="newsletter-signup__subtitle">{subtitle}</p>
        </div>
      </div>

      <form className="newsletter-signup__body">
        <Input
          type="text"
          name="email"
          placeholder="* Email"
          className="newsletter-signup__input"
          required="required"
          onChange={({ event, value }) => handleChange(event, value)}
          value={email}
        />

        <Button
          type="button"
          name="button"
          data-gtm-id="newsletter-signup"
          className={buttonClass}
          disabled={!isEmailSet}
          onClick={() => setModalOpen(true)}>
          Submit
        </Button>
      </form>

      {modalOpen && (
        <div className="newsletter-signup__overlay">
          <ModalInText
            closeModal={() => {
              setModalOpen(false);
              setValues({ email: '' });
            }}
            passedEmail={email}
            product={product}
            subtitle={subtitle}
            title={title}
          />
        </div>
      )}
    </div>
  );
};

FormInText.propTypes = {
  product: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default FormInText;
